"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var index_1 = __importDefault(require("../../../../images/misc/index"));
var Div_1 = __importDefault(require("../Div"));
var columnData = [
    {
        id: 'name',
        label: 'Lajin kauppanimi',
        extraLabel: 'Tieteellinen nimi',
        widthOneTable: '600px',
        widthTwoTable: '350px'
    },
    { id: 'origin', label: 'Alkuperä', widthOneTable: '330px', widthTwoTable: '130px' },
    { id: 'productionMethod', label: 'Tuotantotapa', widthOneTable: '330px', widthTwoTable: '180px' },
    { id: 'catchDate', label: 'Pyyntipäivä', widthOneTable: '330px', widthTwoTable: '150px' },
    { id: 'catchType', label: 'Pyydystyyppi' }
];
var productionMethodTranslation = {
    catched: 'Pyydetty',
    farmed: 'Viljelty'
};
var types = [
    { type: 'hook', label: 'Koukku' },
    { type: 'drag', label: 'Laahusreki' },
    { type: 'trap', label: 'Merta' },
    { type: 'seine', label: 'Nuotta' },
    { type: 'blockade', label: 'Saartopyydys' },
    { type: 'trawl', label: 'Trooli' },
    { type: 'net', label: 'Verkko' },
    { type: 'fyke', label: 'Rysä' }
];
var generateTableStyles = function (tablesCount, tableIndex) {
    return tablesCount === 2 && typeof tableIndex === 'number'
        ? {
            borderCollapse: 'collapse',
            width: '100%',
            color: 'white',
            float: 'left',
            animation: 'fadeIn 2s',
            textAlign: 'left'
        }
        : {
            borderCollapse: 'collapse',
            width: '100%',
            color: 'white',
            float: 'left',
            animation: 'fadeIn 2s',
            textAlign: 'left'
        };
};
var ItemTable = function (_a) {
    var items = _a.items, tablesCount = _a.tablesCount, tableIndex = _a.tableIndex;
    return (react_1.default.createElement(material_1.Grid, { item: true, xs: tablesCount === 2 ? 6 : 12 },
        react_1.default.createElement("table", { style: generateTableStyles(tablesCount, tableIndex) },
            react_1.default.createElement("thead", { style: tablesCount === 2 ? { verticalAlign: 'top' } : {} },
                react_1.default.createElement("tr", { style: { borderBottom: '1px solid white' } }, columnData.map(function (_a) {
                    var colId = _a.id, label = _a.label, extraLabel = _a.extraLabel, widthTwoTable = _a.widthTwoTable, widthOneTable = _a.widthOneTable;
                    return (react_1.default.createElement("th", { key: colId, style: { width: tablesCount === 2 ? widthTwoTable : widthOneTable } },
                        react_1.default.createElement("div", { style: {
                                fontWeight: 'bold',
                                fontSize: '1.1em',
                                textTransform: 'uppercase',
                                fontFamily: 'Skatta Sans Bold'
                            } }, label),
                        extraLabel && (react_1.default.createElement("div", { style: { fontStyle: 'italic', fontWeight: 'normal' } }, extraLabel))));
                }))),
            react_1.default.createElement("tbody", null, items.map(function (_a, i) {
                var productId = _a.productId, name = _a.name, latinName = _a.latinName, origin = _a.origin, catchArea = _a.catchArea, catchDate = _a.catchDate, catchType = _a.catchType, productionMethod = _a.productionMethod;
                var catchImageSrc = (0, ramda_1.path)(['catchTypes', "".concat(catchType)], index_1.default);
                return (react_1.default.createElement("tr", { key: "".concat(productId, "-").concat(i), style: { borderBottom: '1px solid white' } },
                    react_1.default.createElement("th", null,
                        react_1.default.createElement("div", { style: {
                                textTransform: 'uppercase',
                                fontWeight: 'bold',
                                fontFamily: 'Skatta Sans Bold'
                            } }, name),
                        react_1.default.createElement("div", { style: { fontStyle: 'italic', fontWeight: 'normal' } }, latinName)),
                    react_1.default.createElement("th", null,
                        react_1.default.createElement("div", null, origin),
                        react_1.default.createElement("div", null, catchArea)),
                    react_1.default.createElement("th", null, productionMethod ? productionMethodTranslation[productionMethod] : ''),
                    react_1.default.createElement("th", null, catchDate),
                    react_1.default.createElement("th", null,
                        react_1.default.createElement("div", { style: {
                                height: '90px',
                                padding: '5px'
                            } }, catchImageSrc && (react_1.default.createElement("img", { alt: "".concat(catchType, "-").concat(i), src: catchImageSrc, style: {
                                height: '90px'
                            } }))))));
            })))));
};
var CatchTypesFooter = function () { return (react_1.default.createElement("div", { style: {
        color: 'white',
        position: 'absolute',
        bottom: '20px',
        width: '100%',
        borderTop: '2px solid white',
        paddingTop: '10px',
        paddingBottom: '10px'
    } },
    react_1.default.createElement(material_1.Grid, { container: true, direction: 'row', justifyContent: 'center' }, types.map(function (_a) {
        var type = _a.type, label = _a.label;
        return (react_1.default.createElement(material_1.Grid, { item: true, key: "type-".concat(type), style: { height: '100px', width: '232px' } },
            react_1.default.createElement("img", { alt: type, src: index_1.default.catchTypes[type], style: {
                    height: '100%',
                    verticalAlign: 'middle',
                    margin: '5px 10px'
                } }),
            label));
    })))); };
var splitItemsToTables = function (items, limit) {
    if (items.length > limit) {
        return [
            {
                items: items.slice(0, limit)
            },
            {
                items: items.slice(limit)
            }
        ];
    }
    return [
        {
            items: items
        }
    ];
};
var FishItems = function (_a) {
    var items = _a.items, id = _a.id;
    var itemTables = splitItemsToTables(items, 8);
    return (react_1.default.createElement(Div_1.default, { id: id, styles: {
            backgroundColor: 'black',
            fontFamily: 'Skatta Sans Regular',
            fontSize: '18px',
            height: '1920px',
            width: '100%',
            color: 'white',
            backgroundImage: "url(".concat(index_1.default.blackBoard, ")")
        } },
        react_1.default.createElement(material_1.Grid, { container: true, direction: 'row', justifyContent: 'center', style: { padding: '15px' }, spacing: 2 }, itemTables.length > 1 ? (react_1.default.createElement(react_1.Fragment, null, itemTables.map(function (_a, index) {
            var currentItems = _a.items;
            return (react_1.default.createElement(ItemTable, { key: "table-".concat(index), items: currentItems, tablesCount: itemTables.length, tableIndex: index }));
        }))) : (react_1.default.createElement(ItemTable, { key: 'table-full-width', items: items }))),
        react_1.default.createElement(CatchTypesFooter, null)));
};
exports.default = FishItems;
//# sourceMappingURL=FishItems.js.map